import React from 'react'
import {useTranslation} from 'react-i18next'
import {isMobile} from 'react-device-detect'
import styled from 'styled-components'

const Option = styled.span.attrs({
  className: ''
})`
  &:hover {
    color: var(--bs-primary);
  }
`

const LanguagesFilter = (props) => {
  const {machine} = props
  const [current, send] = machine
  const {i18n} = useTranslation()

  const languages = [
    { label: i18n.t('format:languages.spanish'), value: 'es' },
    { label: i18n.t('format:languages.english'), value: 'en' },
    { label: i18n.t('format:languages.french'), value: 'fr' },
    { label: i18n.t('format:languages.italian'), value: 'it' },
    { label: i18n.t('format:languages.chinese'), value: 'zh' }
  ]

  const languageFilterd = current.context.filters.find(
    (filter) => filter.param === 'language_code'
  )
  const languageFilterValue = languageFilterd && languageFilterd.value

  const onTourTypeFilter = (language) => {
    if (languageFilterValue === language.value) {
      send({ type: 'FILTER_REMOVE', param: 'language_code' })
    } else {
      send({
        type: 'FILTER_SELECTION',
        filter: {
          param: 'language_code',
          label: language.label,
          value: language.value
        }
      })
    }

    if (isMobile) {
      props.setIsOpen(!props.isOpen)
    }
  }

  return (
    <>
      {languages.map((language) => (
        <div key={language.value} className="mb-1">
          <input
            type="radio"
            className="me-2"
            checked={language.value === languageFilterValue}
            onChange={() => onTourTypeFilter(language)}
            style={{ cursor: 'pointer' }}
          />
          <label
            onClick={() => onTourTypeFilter(language)}
            style={{ cursor: 'pointer' }}
          >
            <Option className={language.value === languageFilterValue ? 'fw-semibold' : 'fw-normal'}>{language.label}</Option>
          </label>
        </div>
      ))}
    </>
  )
}

export default LanguagesFilter
